/**
 * Created by afuhr on 07.07.2016.
 */
import {RouterModule, Routes} from "@angular/router";
import {VisbosClientComponent} from "./visbos-client.component";
import {storageRoutes} from "../store-management/store-management.routes";
import {AuthorizedGuard} from "../shared/auth/guards/authorized-guard";
import {medicineStickersRoutes} from "../medicine-stickers/medicine-stickers-routing";
import {WelcomeViewComponent} from "./welcome-view/welcome-view.component";
import {ProfileViewComponent} from "../crm/components/profile-view/profile-view.component";
import {sensorsRoutes} from "../sensors/sensors-routing";
import {adminRoutes} from "../admin/admin-routing";


const visbosClientRoutes: Routes = [
  {
    path: 'client',
    component: VisbosClientComponent,
    canActivate: [AuthorizedGuard],
    canActivateChild: [AuthorizedGuard],
    children: [
      {
        path: '',
        component: WelcomeViewComponent
      },
      {
        path: 'profil',
        component: ProfileViewComponent
      },
      ...storageRoutes,
      ...medicineStickersRoutes,
      ...sensorsRoutes,
      ...adminRoutes
    ]
  },

];

//TODO: Adapt path to standard value of logged in user

export const visbosClientRoutingProviders: any[] = [];

export const visbosClientRouting = RouterModule.forChild(visbosClientRoutes);




// WEBPACK FOOTER //
// ./src/app/visbos-client/visbos-client.routes.ts